import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";

export default function EncouragementTicker() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const r = await api.get("/encouragements");
        if (!cancelled) setItems((r.data || []).slice(0, 20));
      } catch {}
    };
    load();
    const t = setInterval(load, 60000);
    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, []);

  if (items.length === 0) return null;

  // Duplicate for seamless loop
  const loop = [...items, ...items];

  return (
    <div
      className="relative border-y border-white/5 bg-gradient-to-r from-[#0A1020] via-[#0F172A] to-[#0A1020] overflow-hidden"
      data-testid="encouragement-ticker"
      aria-label="Mots bienveillants de la communauté"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-3 flex items-center gap-4">
        <div className="hidden sm:flex items-center gap-2 shrink-0 text-xs em-eyebrow">
          <Heart className="w-3.5 h-3.5" /> Mots bienveillants
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="em-ticker-track flex gap-10 whitespace-nowrap">
            {loop.map((m, i) => (
              <span
                key={`${m.id}-${i}`}
                className="inline-flex items-center gap-2 text-sm text-slate-200"
              >
                <Heart className="w-3.5 h-3.5 text-rose-400 shrink-0" />
                <span className="text-slate-100">« {m.message} »</span>
                <span className="text-slate-500">— {m.author}</span>
              </span>
            ))}
          </div>
          {/* Fade edges */}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-[#0A1020] to-transparent" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-[#0A1020] to-transparent" />
        </div>
      </div>
    </div>
  );
}
